import type { Transition, Variants } from 'framer-motion';

export const userNavEase: Transition = {
  duration: 0.28,
  ease: [0.22, 1, 0.36, 1],
};

export const userNavSpring: Transition = {
  type: 'spring',
  stiffness: 420,
  damping: 34,
  mass: 0.85,
};

export const userNavPanelVariants: Variants = {
  initial: { opacity: 0, y: 10, scale: 0.98 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: 6, scale: 0.98 },
};

export const userNavSheetVariants: Variants = {
  initial: { y: '100%' },
  animate: { y: 0 },
  exit: { y: '100%' },
};

export const userNavBackdropVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const userNavListVariants: Variants = {
  initial: {},
  animate: { transition: { staggerChildren: 0.045, delayChildren: 0.06 } },
  exit: { transition: { staggerChildren: 0.02, staggerDirection: -1 } },
};

export const userNavItemVariants: Variants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 8 },
};

export const userNavTransition = (reduceMotion: boolean | null): Transition =>
  reduceMotion ? { duration: 0.01 } : userNavEase;

export const userNavSpringTransition = (reduceMotion: boolean | null): Transition =>
  reduceMotion ? { duration: 0.01 } : userNavSpring;
